import React from 'react';
import { DoorDesignerApp } from '../journey/DoorDesignerApp';
import '../ui/styles.css';

/**
 * JARVIS host for the customer Door Designer.
 * Same component tree as the future public iframe/embed.
 */
export const DoorDesignerPage: React.FC = () => <DoorDesignerApp hardwareDebugToggle />;

export default DoorDesignerPage;
